angular.module("sdEventModule", []);
angular.module("sdRouteModule", []);
angular.module("beforeSdApp", []);
const app = angular.module("sdApp", [
  "angular-cache",
  "ngResource",
  "ngSanitize",
  "sdEventModule",
  "sdRouteModule",
  "sdApp.config",
  "sdLogger",
  "sdServicesModule",
  "sdApp.preference",
  "sdApp.Recovery",
  "sdApp.sdAbout",
  "sdApp.ReleaseNotes",
  "sdApp.Filter",
  "sdApp.agentAction",
  "sdApp.availability",
  "sd.feedback.component",
  "ui.router",
  "oc.lazyLoad",
  "ct.ui.router.extras.dsr",
  "ct.ui.router.extras.statevis",
  "sdDirectives",
  "eaeControls",
  "eaeInteraction",
  "sdLocalization",
  "ngAnimate",
  "agGrid",
  "vs-repeat",
  "beforeSdApp",
  "moment-picker",
  "ng.deviceDetector"
]);

export default app;

// Angular Module.
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { UpgradeModule } from "@angular/upgrade/static";

// All Angular components are registered here.
@NgModule({
  imports: [BrowserModule, UpgradeModule]
})
export class AppModule {
  constructor(private upgrade: UpgradeModule) {}

  // Upgrade module is used to bootstrap AngularJS modules
  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, ["sdApp"]);
  }
}
